import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import ConfirmarPreaprobado from "../../pages/solicitudes/PrestamoPreaprobadoConfirmar";
import { trackPromise } from 'react-promise-tracker';
// import "react-input-range/lib/css/index.css"
import Popup from "react-popup";
import { formatoSeparadorMilesValue, splitImporte } from "../../generico/utils/FormatoInput";
import DatosSocio from "../../generico/DatosSocio"
import $ from "jquery";
import Select from "react-select";
import MensajeUsuario from "../../generico/MensajeUsuario";
import PrestamoPreaprobadoService from '../../../services/solicitudes/PrestamoPreaprobadoService';
import history from "../../pages/login/history";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

var prestamo = {
  minMonto:undefined, 
  maxMonto:undefined, 
  monto:undefined,
  plazo:undefined,
  sucursal:undefined
};
var montoCuota = {
  montoIngresado:undefined, 
  sucursalId:undefined, 
};
export default class PrestamoPreaprobado extends Component {
  

  constructor(props) {
    super(props);
    this.state = {      
      monto: "500.000",
      value: 500000,
      plazo: undefined,
      sucursalDesembolso: undefined,
      sucursalDesembolsoLabel: undefined,
      montoLimInf: 500000,
      limiteSuperior: undefined,
      sucursalList:[],
      plazosList:[],
      itemsConfirm: [],
      itemsMoraCompromiso: [],
      moraCompromisoTotal:0,
      totalDesembolso:0
    };
  }

  componentDidMount() {
    var saldoLinea = sessionStorage.getItem("saldoLinea");
    if(saldoLinea === null || saldoLinea === undefined || saldoLinea === ""){
      this.redirigirResumenGeneral();
    }
    this.setState({limiteSuperior: saldoLinea});
    sessionStorage.removeItem("saldoLinea");

    prestamo.maxMonto = saldoLinea;
    prestamo.minMonto = this.state.montoLimInf;
    prestamo.monto = this.state.montoLimInf;
    montoCuota.montoIngresado = this.state.montoLimInf;

    this.obtenerSucursalDesembolso();
    this.obtenerplazo();
    this.habilitarBoton();
  }

  redirigirResumenGeneral(){
    //history.push("/resumenGeneralSocio");
    history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
    window.location.reload();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  loadDataConfirm() {

    $.validator.setDefaults({
      submitHandler: () => {
        this.obtenerMoraCredito();
      }
    });
    $("#idPreaprobadoForm").submit(function (e) {

      e.preventDefault();         
      var data = {};
      var dataArray = $('#idPreaprobadoForm').serializeArray();
      for (var i = 0; i < dataArray.length; i++) {
        data[dataArray[i].name] = dataArray[i].value;
        if(dataArray[i].name ==="sucursalDesembolso" && dataArray[i].value === ""){
          var prueba = document.getElementById('sucursalDesembolso-div')
          prueba.classList.add("prueba")
          $('#sucursal-error').show()
          continue;
        }
        if(dataArray[i].name ==="sucursalDesembolso" && dataArray[i].value !== ""){
          var prueba = document.getElementById('sucursalDesembolso-div')
          prueba.classList.remove("prueba")
          $('#sucursal-error').hide() 
          continue;
        }
        if(dataArray[i].name ==="plazo" && dataArray[i].value === ""){
          var prueba = document.getElementById('plazo-div')
          prueba.classList.add("prueba")
          $('#plazo-error').show()
          continue;
        }
        if(dataArray[i].name ==="plazo" && dataArray[i].value !== ""){
          var prueba = document.getElementById('plazo-div')
          prueba.classList.remove("prueba")
          $('#plazo-error').hide()
          continue;
        }
        if(dataArray[i].name ==="monto" && dataArray[i].value === ""){
          var prueba = document.getElementById('monto-div')
          prueba.classList.add("prueba")
          continue;
        }
        if(dataArray[i].name ==="monto" && dataArray[i].value !== ""){
          var prueba = document.getElementById('monto-div')
          prueba.classList.remove("prueba")
          continue;
        }
      }


      $.validator.addMethod(
        "montoMin",
        function (value, element) {
          var monto = String(element.value).replace(/\./g, "");
          if (Number.parseInt(monto) < prestamo.minMonto){
            return false;
          }else{
            return true;
          }
        }
      );
      $.validator.addMethod(
        "montoMax",
        function (value, element) {
          var monto = String(element.value).replace(/\./g, "");
          if (Number.parseInt(monto) > prestamo.maxMonto){
            return false;
          }else{
            return true;
          }
        }
      );

    }).validate(
      {
        rules: {
          sucursalDesembolso: {
            required: true,
          },
          plazo: {
            required: true,
          },
          monto: {
            required: true,
            montoMin: { montoMin: false },
            montoMax: { montoMax: false },
          }
        },
        messages: {
          sucursalDesembolso: {
            required: "Este campo es requerido",
          },
          plazo: {
            required: "Este campo es requerido",
          },
          monto: {
            required: "Este campo es requerido",
            montoMin:"El monto mínimo a solicitar es de Gs. "+ formatoSeparadorMilesValue(prestamo.minMonto),
            montoMax:"El monto máximo a solicitar es de Gs. "+ formatoSeparadorMilesValue(prestamo.maxMonto)
          }

        },
        errorElement: "span",
        errorPlacement: function (error, element) {
          error.addClass("invalid-feedback");
          $(element).addClass("is-invalid");
          element.closest(".form-group").append(error);
        },

        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass("is-invalid");
        },
      });


  }


  onChangeValue = (e) => {
    var numero = e.target.value
    var importe = splitImporte(numero);
    montoCuota.montoIngresado = importe;
    this.setState({ value: importe, monto: importe })
    var _monto = formatoSeparadorMilesValue(importe);
    if(_monto.length>1 && _monto.substr(0,1)==="0"){
      _monto = _monto.substr(1);
    }
    document.getElementById('monto').value = _monto;
    prestamo.monto = importe;
    this.habilitarBoton();    
    this.obtenerMontoCuota();    
  }


  confirmarBtn = () => {
    trackPromise(
      PrestamoPreaprobadoService.confirmarSolicitud(this.state.value, this.state.plazo, this.state.sucursalDesembolso, "GS")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);

          if (jsonData.codigoRetorno === "0") {
            this.modalCtrlExito.click();
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
            return;
          }
        }
      ));
  }

  obtenerSucursalDesembolso() {
    trackPromise(
      PrestamoPreaprobadoService.getSucursalDesembolso()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);

          if (jsonData.codigoRetorno === "0") {
            for (var i = 0; i < jsonData.datos.length; i++) {
              this.state.sucursalList.push({
                value: jsonData.datos[i].codigo,
                label: jsonData.datos[i].descripcion,
              });
            }
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
            return;
          }
        }

      ));
  }

  handleChangeSelectorDesembolso = (selectedOption) => {
    if (selectedOption === null)
      this.setState({
        sucursalDesembolso: undefined
      });
    else{
      this.setState({
        sucursalDesembolso: selectedOption.value
      });
      prestamo.sucursal=selectedOption.value
      this.habilitarBoton();
    }  
  };

  obtenerplazo() {
    trackPromise(
      PrestamoPreaprobadoService.getPlazos()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigoRetorno === "0") {
            for (var i = 0; i < jsonData.datos.length; i++) {
              this.state.plazosList.push({
                value: jsonData.datos[i],
                label: jsonData.datos[i]+ " MESES",
              });
            }
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
            return;
          }
        }

      ));
  }

  handleChangeSelectorPlazo = (selectedOption) => {
    if (selectedOption === null){
        this.setState({plazo: undefined});
    }    
    else{
      this.setState({plazo: selectedOption.value});
      prestamo.plazo = selectedOption.value;
      montoCuota.plazo = selectedOption.value;      
      this.habilitarBoton();
      this.obtenerMontoCuota();
    }  
  };

  habilitarBoton() {
    if (prestamo.sucursal !== undefined &&
      prestamo.plazo !== undefined &&
      prestamo.monto !== undefined) {
        this.btnHabilitar.disabled = false;
    } else {
        this.btnHabilitar.disabled = true;
    }
  }

  obtenerMoraCredito() {
    if(this.state.plazo===undefined || this.state.plazo ===""){
      return false;
    }
    if(this.state.sucursalDesembolso===undefined || this.state.sucursalDesembolso ===""){
      return false;
    }
    if(this.state.value===undefined || this.state.value ===""){
      return false;
    }

    trackPromise(
      PrestamoPreaprobadoService.getMoraCredito().then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigoRetorno === "0") {
            //// existe mora de crédito del socio
            if(jsonData.datos.totalMora>0){
              var mensaje = "Para acceder a tu crédito deberás regularizar el pago de tus obligaciones pendientes. Para mayor información comunicate al 617 00 00.";
              Popup.queue(this.notifiPopup("Crédito en mora", mensaje));
              return;
            }
            //// existe mora de crédito como codeudor
            if(jsonData.datos.existeDeuda==='S'){
              var mensaje = "Para acceder a tu crédito deberás regularizar el pago de tus obligaciones pendientes. Para mayor información comunicate al 617 00 00.";
              Popup.queue(this.notifiPopup("Crédito en mora - Cónyuge/Garantidos", mensaje));
              return;
            }  
            //// mora por obligaciones societarias
            this.obtenerMoraCompromiso();
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
            return;
          }
        }

      ));
  }    

  obtenerMoraCompromiso() {
      trackPromise(
        PrestamoPreaprobadoService.getMoraCompromiso(this.state.value)
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            if (jsonData.codigoRetorno === "0") {

              //// posee deuda de aporte
              var sumDeuda = jsonData.datos.depositarAporte + jsonData.datos.moraSolidaridad + jsonData.datos.moraAporteConyuge + jsonData.datos.moraSolidaridadConyuge
              if(sumDeuda>0){
                var totalDesembolso = this.state.value - sumDeuda

                var _itemsMoraCompromiso = [
                  { concepto: "Mora Aporte / Relación Aporte", valor: formatoSeparadorMilesValue(jsonData.datos.depositarAporte) + " Gs. " },
                  { concepto: "Mora Solidaridad", valor: formatoSeparadorMilesValue(jsonData.datos.moraSolidaridad) + " Gs. " },
                  { concepto: "Mora Aporte del Cónyuge", valor: formatoSeparadorMilesValue(jsonData.datos.moraAporteConyuge) + " Gs. " },
                  { concepto: "Mora Solidaridad del Cónyuge", valor: formatoSeparadorMilesValue(jsonData.datos.moraSolidaridadConyuge) + " Gs. " },
                ];
                this.setState({ 
                  itemsMoraCompromiso: _itemsMoraCompromiso,
                  moraCompromisoTotal: sumDeuda,
                  totalDesembolso: totalDesembolso
                });
              }
              
              var sucursalSelect = this.state.sucursalList.find(x=>x.value === this.state.sucursalDesembolso)
              this.state.sucursalDesembolsoLabel = sucursalSelect.label;
              var montoSolicitado = Number(this.state.value).toString();
              var _itemsConfirm = [
                { concepto: "Sucursal del Desembolso", valor: sucursalSelect.label },
                { concepto: "Plazo (meses)", valor: this.state.plazo },
                { concepto: "Monto de Crédito", valor: formatoSeparadorMilesValue(montoSolicitado) + " Gs." },
              ];
              this.setState({ itemsConfirm: _itemsConfirm });
              ///// levanta popup de confirmación de crédito
              this.modalCtrlConfirm.click();
            }
            else {
              Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
              return;
            }
          }

        ));
  }  

  obtenerMontoCuota = async () => {
    if(montoCuota.plazo !== undefined && 
      Number(montoCuota.montoIngresado)>=Number(this.state.montoLimInf) && 
      Number(montoCuota.montoIngresado)<=Number(this.state.limiteSuperior)){
      
      await trackPromise(
        PrestamoPreaprobadoService.getMontoCuota(montoCuota.montoIngresado, montoCuota.plazo)
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            if (jsonData.codigoRetorno === "0") {
              $("#montoCuota").text(formatoSeparadorMilesValue(jsonData.datos.montoCuota)); 
              $("#tasaInteres").text(jsonData.datos.tasaInteres);
            }
            else {
              Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
              return;
            }
          }

        ));

    }  
  }

  // obtenerMontoCuota() {
  //   if(montoCuota.plazo !== undefined && 
  //     Number(montoCuota.montoIngresado)>=Number(this.state.montoLimInf) && 
  //     Number(montoCuota.montoIngresado)<=Number(this.state.limiteSuperior)){
  //     console.log(montoCuota.plazo) 
  //     console.log(montoCuota.montoIngresado)  
  //     trackPromise(
  //       PrestamoPreaprobadoService.getMontoCuota(montoCuota.montoIngresado, montoCuota.plazo)
  //         .then((response) => {
  //           var data = JSON.stringify(response.data);
  //           var jsonData = JSON.parse(data);
  //           if (jsonData.codigoRetorno === "0") {
  //             $("#montoCuota").text(formatoSeparadorMilesValue(jsonData.datos.montoCuota)); 
  //             $("#tasaInteres").text(jsonData.datos.tasaInteres);
  //           }
  //           else {
  //             Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
  //             return;
  //           }
  //         }

  //       ));

  //       return (
  //         <>
  //         {this.state.plazo!==undefined && (
  //           <div className="form-group" >
  //             <label className="input-label-bold limite-minimo-label" >
  //               Monto Estimado de Cuota : <span id="montoCuota"></span> GS.<br/>
  //               Tasa de Interés : <span id="tasaInteres"></span>%
  //             </label>
  //           </div>
  //         )} 
  //         </>  
  //       );

  //   }  
  // }  

  render() {
    var montoActual = this.state.monto
    return (
      <div className="content-wrapper">
        <ConfirmarPreaprobado
          idModal="idModalConfirm"
          title="Solicitud de Préstamo"
          items={this.state.itemsConfirm}
          itemsMora={this.state.itemsMoraCompromiso}
          moraCompromisoTotal={this.state.moraCompromisoTotal}
          totalDesembolso={this.state.totalDesembolso}
          moneda = "GS"
          confirmarBtn={this.confirmarBtn.bind(this)}
        />
        <Titulo texto="Solicitud de Préstamo" />
        <section className="content">
          <form id="idPreaprobadoForm">
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="col-lg-8 col-md-10">
                  <div className="card">
                    <div className="card-header">
                      <DatosSocio/>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <MensajeUsuario tipo="INFO"
                            titulo="Importante."
                            mensaje="Completando el siguiente formulario se te otorgará un crédito que podrás 
                            desembolsarlo en la sucursal seleccionada." />
                        </div>
                      </div> 
                      <div className="row">
                        <div className="col-md-12">                          
                          <div className="form-group">
                            <label className="input-label">Sucursal Desembolso *</label>
                            <div className="is-invalid" id="sucursalDesembolso-div">
                              <Select name="sucursalDesembolso" id="sucursalDesembolso"
                                ref="sucursal-desembolso-ref"
                                defaultValue={this.state.sucursalDesembolso}
                                onChange={this.handleChangeSelectorDesembolso}
                                placeholder="-- seleccione --"
                                options={this.state.sucursalList}
                                noOptionsMessage={() => 'SIN DATOS'}
                              />  
                            </div>
                            <div id="sucursal-error" className="error" 
                              style={{width:"100%", marginTop: ".25rem", fontSize: "80%", color: "#dc3545", display:"none"}}>
                                Este campo es requerido
                            </div>         
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">                          
                          <div className="form-group">
                            <label className="input-label">Plazo *</label>
                            <div className="is-invalid" id="plazo-div">
                              <Select name="plazo" id="plazo"
                                ref="plazo-ref"
                                defaultValue={this.state.plazo}
                                onChange={this.handleChangeSelectorPlazo}
                                placeholder="-- seleccione --"
                                options={this.state.plazosList}
                                noOptionsMessage={() => 'SIN DATOS'}
                              /> 
                            </div>
                            <div id="plazo-error" className="error" 
                              style={{width:"100%", marginTop: ".25rem", fontSize: "80%", color: "#dc3545", display:"none"}}>
                                Este campo es requerido
                            </div>         
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label className="input-label">Ingresar el monto a solicitar *</label>
                            <div className="is-invalid" id="monto-div">
                              <input id="monto" name="monto" type="text" placeholder="monto a solicitar"
                              className="form-control input-box" defaultValue={montoActual}  onKeyUp={this.onChangeValue}/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row float-right" style={{ paddingLeft: 8, marginRight: -30 }}>
                        <div className="col-md-12">
                          {this.state.plazo!==undefined && 
                          Number(montoCuota.montoIngresado)>=Number(this.state.montoLimInf) && 
                          Number(montoCuota.montoIngresado)<=Number(this.state.limiteSuperior) && (
                            <div className="form-group" >
                              <label className="input-label-bold limite-minimo-label" >
                                Monto Estimado de Cuota : <span id="montoCuota"></span> GS.<br/>
                                {/* Tasa de Interés : <span id="tasaInteres"></span>% */}
                              </label>
                            </div>
                          )} 
                        </div> 
                      </div> 
                    </div>
                     
                    <div className="card-footer">
                      <div className="row">
                        <div className="col-md-9">
                        <label className="input-label-bold-obligatorio">
                          (*) Campos Obligatorios
                      </label>
                        </div>
                        <div className="col-md-3">
                        <button 
                      ref={(button) => (this.btnHabilitar  = button)} 
                      className="btn btn-cu-primary float-right" 
                      onClick={() => this.loadDataConfirm()}>
                      <FontAwesomeIcon icon={faPaperPlane} />  Enviar
                      </button>
                        </div>
                      </div>
                       
                     
                      <a
                        ref={(a) => (this.modalCtrlConfirm = a)}
                        href="#"
                        hidden
                        id="modalCtrlConfirm"
                        data-toggle="modal"
                        data-target="#idModalConfirm"
                      ></a>
                      <a
                        ref={(a) => (this.modalCtrlExito = a)}
                        href="#"
                        hidden
                        id="modalCtrlExito"
                        data-toggle="modal"
                        data-target="#procesoExitoso"
                        data-backdrop="static" 
                        data-keyboard="false"
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
        
        {/*####################### POPUP PROCESO EXITOSO ############################*/}
        <div className="modal fade" id="procesoExitoso">
          <div className="modal-dialog modal-lg">
              <div className="modal-content">
                  <div className="modal-header">
                      <h5 className="modal-title">
                          ¡LISTO!{" "}<i className="fa fa-check" style={{color: "#007c34"}} aria-hidden="true" />
                      </h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                      </button>
                  </div>
                  <div className="modal-body">    
                      <div className="row">
                          <div className="col-12">
                              <section className="content">
                                  <div className="container-fluid">                           
                                      <div className="row invoice-info">
                                          <div className="col-12">
                                            <h6 style={{color: "#525252",marginBottom: 0}}>
                                            Tu crédito por Gs. {formatoSeparadorMilesValue(this.state.value)} se ha confirmado.<br/> 
                                            Te esperamos en la Sucursal {this.state.sucursalDesembolsoLabel} para retirarlo.<br/> 
                                            Recordá traer tu documento de identidad y una copia de tu factura de servicio básico.
                                            </h6>
                                          </div>
                                      </div>
                                      <hr/>
                                      <div className="row invoice-info">
                                        <div className="col-12">
                                          <div className="row">
                                            <div className="col-12">
                                              <button onClick={this.redirigirResumenGeneral}
                                                type="button" className="btn btn-cu-primary float-right" style={{marginRight:"5px"}}>
                                                Aceptar
                                              </button>  
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                  </div>
                              </section>
                          </div>
                      </div>        
                  </div>
                  
              </div>
          </div>
        </div>     

      </div>
    );
  }
}
